import {
  IMPORTER_STATS_REQUEST,
  IMPORTER_STATS_SUCCESS,
  IMPORTER_STATS_FAILURE,
  IMPORTER_STATS_UPDATE_LOG,
  SYNC_REQUEST,
  SYNC_SUCCESS,
  SYNC_FAILURE,
  BULK_SYNC_REQUEST,
  BULK_SYNC_SUCCESS,
} from './actions';

import _ from 'lodash';

import createReducer from 'state/createReducer';

const initialState = {
  request: false,
  errorMessage: null,
  isImporting: false,
  lastImportDates: [],
  importLog: [],
  syncPending: [],
  bulkSyncPending: false,
  bulkSyncIDs: []
}

const handlers = {
  [IMPORTER_STATS_REQUEST](state) {
    return {
      ...state,
      request: true,
      errorMessage: null
    }
  },

  [IMPORTER_STATS_SUCCESS](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: null,
      isImporting: payload.isImporting,
      lastImportDates: payload.lastImportDates
    }
  },

  [IMPORTER_STATS_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: payload.errorMessage
    }
  },

  [IMPORTER_STATS_UPDATE_LOG](state, payload) {

    const importLog = _.cloneDeep(state.importLog)
    importLog.push(payload.data)

    return {
      ...state,
      isImporting: true,
      importLog: importLog,
    }
  },

  [SYNC_REQUEST](state, payload) {
    
    if (state.syncPending.includes(payload.productGroupID) === true) {
      return {
        ...state
      }
    }

    const pending = [...state.syncPending];
    pending.push(payload.productGroupID);

    return {
      ...state,
      syncPending: pending
    }
  },
  [SYNC_SUCCESS](state, payload) {

    if (state.syncPending.includes(payload.productGroupID) === false) {
      return {
        ...state
      }
    }

    const pending = [...state.syncPending];
    const idx = _.findIndex(pending, (o) => {
      return o == payload.productGroupID;
    });

    pending.splice(idx, 1);

    return {
      ...state,
      syncPending: pending
    }
  },
  [SYNC_FAILURE](state, payload) {
    if (state.syncPending.includes(payload.productGroupID) === false) {
      return {
        ...state
      }
    }

    const pending = [...state.syncPending];
    const idx = _.findIndex(pending, (o) => {
      return o == payload.productGroupID;
    });

    pending.splice(idx, 1);

    return {
      ...state,
      syncPending: pending
    }
  },
  [BULK_SYNC_REQUEST](state, payload) {
    return {
      ...state,
      bulkSyncPending: true,
      bulkSyncIDs: payload
    }
  },
  [BULK_SYNC_SUCCESS](state, payload) {
    return {
      ...state,
      bulkSyncPending: false,
      bulkSyncIDs: []
    }
  }

}

export default (state = initialState, action) => createReducer(state, action, handlers); 
